module.exports = __webpack_public_path__ + "img/hc_pro_five_6.d9e29a1b.jpg";